import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { post, put } from '../../utils/api';
import { Form, FormLine, FormItem, FormInput } from '../common/Form';
import { useSelector } from 'react-redux';
//
// Компонент для создания и редактирования мероприятия
//
const EventForm = ({ event }) => {
	const { t } = useTranslation();
    const user = useSelector(state => state.auth.user);
	const navigate = useNavigate();
	const [ nameRu, setNameRu ] = useState(event ? event.name.ru : '');
	const [ nameEn, setNameEn ] = useState(event ? event.name.en : '');
    const [ catalogUrlRu, setCatalogUrlRu ] = useState(event ? event.catalog_url.ru : '');
    const [ catalogUrlEn, setCatalogUrlEn ] = useState(event ? event.catalog_url.en : '');
    const [ scheduleUrlRu, setScheduleUrlRu ] = useState(event ? event.schedule_url.ru : '');
    const [ scheduleUrlEn, setScheduleUrlEn ] = useState(event ? event.schedule_url.en : '');
	const [ catMainRu, setCatMainRu ] = useState(event ? event.category_name.main.ru : 'Категории');
	const [ catMainEn, setCatMainEn ] = useState(event ? event.category_name.main.en : 'Categories');
	const [ catAddonRu, setCatAddonRu ] = useState(event ? event.category_name.addon.ru : 'Дополнительные');
	const [ catAddonEn, setCatAddonEn ] = useState(event ? event.category_name.addon.en : 'Additional');
	const [ catAdminRu, setCatAdminRu ] = useState(event ? event.category_name.admin.ru : 'Специальные');
	const [ catAdminEn, setCatAdminEn ] = useState(event ? event.category_name.admin.en : 'Special');
    const [ diplomNameChangeDate, setDiplomNameChangeDate ] = useState(event ? event.diplom_name_change_date ?? '' : '');
    const [ isFilesAvailable, setIsFilesAvailable ] = useState(event ? event.is_files_available : false);
    const [ isArchived, setIsArchived ] = useState(event ? event.is_archived : false);
    const [ success, setSuccess ] = useState('');
    const [ isSaving, setIsSaving ] = useState(false);
    const [ saveError, setSaveError ] = useState('');

    const checkURL = (url) => {
        let checked = url.trim();
        if(checked && !checked.match(/^https?:\/\//i)) {
            checked = 'https://' + checked;
        }
        return `${checked} `;
    };

    const checkDate = (date) => {
        const check = date.trim();
        return check ? /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(check) : true;
    };

    // Отправка данных
	const onSubmit = async () => {
        if(!checkDate(diplomNameChangeDate)) {
            alert(t('eventform.diplom_name_change_invalid_date'));
            return;
        }

        setIsSaving(true);
        setSaveError('');
        setSuccess('');

        const data = {
            name_ru: nameRu,
            name_en: nameEn,
            catalog_url_ru: checkURL(catalogUrlRu),
            catalog_url_en: checkURL(catalogUrlEn),
            schedule_url_ru: checkURL(scheduleUrlRu),
            schedule_url_en: checkURL(scheduleUrlEn),
            category_name_main_ru: catMainRu.trim(),
            category_name_main_en: catMainEn.trim(),
            category_name_addon_ru: catAddonRu.trim(),
            category_name_addon_en: catAddonEn.trim(),
            category_name_admin_ru: catAdminRu.trim(),
            category_name_admin_en: catAdminEn.trim(),
            diplom_name_change_date: diplomNameChangeDate.trim(),
            is_files_available: isFilesAvailable,
            is_archived: isArchived,
        };

        let result;
        if(event) {
            result = await put('/events/' + event._id, data);
        } else {
            result = await post('/events', data);
        }

        if(result.error) {
            setSaveError(result.error);
        } else {
            setSuccess(event ? 'eventedit.success_edit' : 'eventedit.success_add');
            const action = event ? '/action/updated' : '/action/created';
			navigate('/cabinet/eventview/' + result.data.event._id + action);
        }
        setIsSaving(false);
	};

    return (
		<div>
	    	<h1>{event ? t('eventform.title_edit') : t('eventform.title_add')}</h1>
			{isSaving ? <span>{t('common.loading')}</span> :
			<Form
                success={success}
                error={saveError}
                info={event ? 'eventform.subtitle_edit' : 'eventform.subtitle_add'}
                wide={true}
                submit={event ? t('eventform.submit_edit') : t('eventform.submit_add')}
                onSubmit={onSubmit}
            >
                {/* Название мероприятия */}
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='nameRu'
                            type='text'
                            value={nameRu}
                            onChange={setNameRu}
                            placeholder={t('eventform.name_ru')}
                            className='lang-ru'
                            required={true}
                            label={t('eventform.name_ru')}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='nameEn'
                            type='text'
                            value={nameEn}
                            onChange={setNameEn}
                            placeholder={t('eventform.name_en')}
                            className='lang-en'
                            required={true}
                            label={t('eventform.name_en')}
                        />
                    </FormItem>
                </FormLine>
                {/* Название для основной категории */}
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='catMainRu'
                            type='text'
                            value={catMainRu}
                            onChange={setCatMainRu}
                            placeholder={t('eventform.cat_main_ru')}
                            className='lang-ru'
                            label={t('eventform.cat_main_ru')}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='catMainEn'
                            type='text'
                            value={catMainEn}
                            onChange={setCatMainEn}
                            placeholder={t('eventform.cat_main_en')}
                            className='lang-en'
                            label={t('eventform.cat_main_en')}
                        />
                    </FormItem>
                </FormLine>
                {/* Название для дополнительной категории */}
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='catAddonRu'
                            type='text'
                            value={catAddonRu}
                            onChange={setCatAddonRu}
                            placeholder={t('eventform.cat_addon_ru')}
                            className='lang-ru'
                            label={t('eventform.cat_addon_ru')}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='catAddonEn'
                            type='text'
                            value={catAddonEn}
                            onChange={setCatAddonEn}
                            placeholder={t('eventform.cat_addon_en')}
                            className='lang-en'
                            label={t('eventform.cat_addon_en')}
                        />
                    </FormItem>
                </FormLine>
                {/* Название для специальной категории */}
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='catAdminRu'
                            type='text'
                            value={catAdminRu}
                            onChange={setCatAdminRu}
                            placeholder={t('eventform.cat_admin_ru')}
                            className='lang-ru'
                            label={t('eventform.cat_admin_ru')}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='catAdminEn'
                            type='text'
                            value={catAdminEn}
                            onChange={setCatAdminEn}
                            placeholder={t('eventform.cat_admin_en')}
                            className='lang-en'
                            label={t('eventform.cat_admin_en')}
                        />
                    </FormItem>
                </FormLine>
                {/* Ссылки на каталог на внешнем сервере типа тильды */}
                <FormLine>
                    <FormItem>
                        <FormInput
                            id='catalogUrlRu'
                            type='text'
                            value={catalogUrlRu}
                            onChange={setCatalogUrlRu}
                            placeholder={t('eventform.catalog_url_ru')}
                            className='lang-ru'
                            label={t('eventform.catalog_url_ru')}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='catalogUrlEn'
                            type='text'
                            value={catalogUrlEn}
                            onChange={setCatalogUrlEn}
                            placeholder={t('eventform.catalog_url_en')}
                            className='lang-en'
                            label={t('eventform.catalog_url_en')}
                        />
                    </FormItem>
                </FormLine>
                {/* Ссылки на расписание на внешнем сервере типа тильды */}
                <FormLine>
                    <FormItem>
                        <FormInput
                            id='scheduleUrlRu'
                            type='text'
                            value={scheduleUrlRu}
                            onChange={setScheduleUrlRu}
                            placeholder={t('eventform.schedule_url_ru')}
                            className='lang-ru'
                            label={t('eventform.schedule_url_ru')}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='scheduleUrlEn'
                            type='text'
                            value={scheduleUrlEn}
                            onChange={setScheduleUrlEn}
                            placeholder={t('eventform.schedule_url_en')}
                            className='lang-en'
                            label={t('eventform.schedule_url_en')}
                        />
                    </FormItem>
                </FormLine>
                {/* Дата до которой можно изменять название для диплома */}
                <FormItem>
                    <FormInput
                        id='diplomNameChangeDate'
                        type='text'
                        value={diplomNameChangeDate}
                        onChange={setDiplomNameChangeDate}
                        placeholder='YYYY-MM-DD HH:MM'
                        label={t('eventform.diplom_name_change_date')}
                        disabled={user.role !== 'root'}
                    />
                </FormItem>
                {/* Флаги разрешения добавления файлов и помещения в архим */}
                <fieldset>
                    <legend>{t('eventform.flags')}</legend>
                    <FormInput
                        id='isFilesAvailable'
                        type='checkbox'
                        value={isFilesAvailable ? 'true' : ''}
                        onChange={() => setIsFilesAvailable(!isFilesAvailable)}
                        label={t('eventform.is_files_available')}
                    />
                    <FormInput
                        id='isArchived'
                        type='checkbox'
                        value={isArchived ? 'true' : ''}
                        onChange={() => setIsArchived(!isArchived)}
                        label={t('eventform.is_archived')}
                    />
                </fieldset>
			</Form>}
		</div>
	);
};

export default EventForm;
